module.exports = __webpack_public_path__ + "media/applicants/x-557b7b0d.svg";